import { get, post } from '../utils/http'
class homeApi {
  // 根据路线id获取旅行团信息
  async TourGroupList(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourGroup/getTourGroupListByLineId',
      params
    )
    return res.data
  }
  async TourismDetail(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/getSwjjScenicTourismDetail',
      params
    )
    return res.data
  }
  async SwjjScenicList(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/getSwjjScenicTourismLineList',
      params
    )
    return res.data
  }
  async swjjOperateCollect(params) {
    const res = await post(
      '/api/content/v1/swjj/scenic/tourismLine/swjjTourismLineOperateCollect',
      params
    )
    return res.data
  }
  async HomeAdvertList(params) {
    const res = await get(
      '/api/content/v1/advert/getPageHomeAdvertList',
      params
    )
    return res.data
  }
  async CategoryList(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/category/getHomePageScenicCategoryList',
      params
    )
    return res.data
  }
  async StrategyGideList(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/strategyGuide/getStrategyGideList',
      params
    )
    return res.data
  }
  async swjjPcTourList(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/swjjPcTourList',
      params
    )
    return res.data
  }
  async SearchPageData(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/getSearchPageData',
      params
    )
    return res.data
  }
  async UserSearchLog(params) {
    const res = await post(
      '/api/content/v1/swjj/scenic/tourismLine/clearUserSearchLog',
      params
    )
    return res.data
  }
  async PcSearchDataList(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/getPcSearchDataList',
      params
    )
    return res.data
  }
  async UserCollectList(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/getUserCollectList',
      params
    )
    return res.data
  }
  async RecommendTitle(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/getPcSwjjRecommendTitle',
      params
    )
    return res.data
  }
  async PcTourList(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/swjjPcTourList',
      params
    )
    return res.data
  }
  async CommentTabData(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/getCommentTabData',
      params
    )
    return res.data
  }
  async CommentList(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/getSwjjLineCommentList',
      params
    )
    return res.data
  }
  async QRCoderList(params) {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/getPcQRCoderList',
      params
    )
    return res.data
  }
  async addressGetList(params) {
    const res = await post(
      '/api/user/v1/swjj/scenic/offLine/address_GetList',
      params
    )
    return res.data
  }
  async addressSave(params) {
    const res = await post(
      '/api/user/v1/swjj/scenic/offLine/address_Save',
      params
    )
    return res.data
  }
  async getProvinceList(params) {
    const res = await post(
      '/api/user/v1/swjj/scenic/offLine/getProvinceList',
      params
    )
    return res.data
  }
  async getCityListByProvinceID(params) {
    const res = await post(
      '/api/user/v1/swjj/scenic/offLine/getCityListByProvinceID',
      params
    )
    return res.data
  }
  async getDistrictListByCityID(params) {
    const res = await post(
      '/api/user/v1/swjj/scenic/offLine/getDistrictListByCityID',
      params
    )
    return res.data
  }
  async getAllOrderPage(params) {
    const res = await post(
      '/api/user/v1/swjj/scenic/offLine/order_GetPage',
      params
    )
    return res.data
  }
  async deleteByAdresssId(params) {
    const res = await post(
      '/api/user/v1/swjj/scenic/offLine/address_DeleteByAdresssId',
      params
    )
    return res.data
  }
  async orderGetByPkId(params) {
    const res = await post(
      '/api/user/v1/swjj/scenic/offLine/order_GetByPkId',
      params
    )
    return res.data
  }
  // 获取境教pc精选线路
  async getScenicPickedLine() {
    const res = await get(
      '/api/content/v1/swjj/scenic/tourismLine/getScenicPickedLine'
    )
    return res.data
  }
  // 获取境教pc热门景点
  async getScenicHostSpot() {
    const res = await get(
      '/api/content/v1/scenic/tour/spot/map/getScenicHostSpot'
    )
    return res.data
  }
  // 获取热门城市
  async getScenicHotCitys() {
    const res = await get('/api/content/v1/swjj/scenic/category/scenicHotCitys')
    return res.data
  }
  // 获取境教pc景点绑定线路列表
  async getScenicSpotLineList(params) {
    const res = await get(
      '/api/content/v1/scenic/tour/spot/map/getScenicSpotLineList',
      params
    )
    return res.data
  }
}

export default new homeApi()
